<template>
  <div
    class="text-link-list-expand-container"
    :class="['text-link-list-expand-container--' + backgroundColor]"
  >
    <div
      class="text-link-list-expand__header"
      :class="{ 'text-link-list-expand__header--border': border }"
      @click="toggleTextLinkListExpand"
    >
      <span
        class="text-link-list-expand__header__text"
        :class="{ 'text-link-list-expand__header__text--bold': bold }"
      >
        {{ text }}
      </span>
      <div class="text-link-list-expand__header__icon">
        <ChevronUp
          v-if="isActive"
          class="text-link-list-expand__header__chevron--up"
          :class="'text-link-list-expand__header__chevron--' + chevronColor"
        />
        <ChevronDown
          v-else
          class="text-link-list-expand__header__chevron--down"
          :class="'text-link-list-expand__header__chevron--' + chevronColor"
        />
      </div>
    </div>
    <transition
      name="accordion"
      @before-enter="beforeEnter"
      @enter="enter"
      @before-leave="beforeLeave"
      @leave="leave"
    >
      <div v-show="isActive" class="text-link-list-expand__body">
        <slot />
      </div>
    </transition>
  </div>
</template>
<script>
import ChevronDown from '../../atoms/svg_icons/ChevronDown'
import ChevronUp from '../../atoms/svg_icons/ChevronUp'
export default {
  components: { ChevronDown, ChevronUp },
  props: {
    border: {
      type: Boolean,
      required: false,
      default: false
    },
    backgroundColor: {
      type: String,
      required: false,
      default: 'white'
    },
    bold: {
      type: Boolean,
      required: false,
      default: false
    },
    text: {
      type: String,
      required: true
    },
    chevronColor: {
      type: String,
      required: false,
      default: 'black'
    }
  },
  data() {
    return {
      isActive: false
    }
  },
  methods: {
    toggleTextLinkListExpand() {
      this.isActive = !this.isActive
    },
    beforeEnter(el) {
      el.style.height = '0'
    },
    enter(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leave(el) {
      el.style.height = '0'
    }
  }
}
</script>
<style lang="scss" scoped>
.text-link-list-expand-container {
  &--white {
    background-color: $white;
  }

  &--gray-3 {
    background-color: $gray-3;
  }

  .text-link-list-expand {
    &__header {
      height: 56px;
      padding: 16px 12px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;

      &:hover {
        opacity: 0.7;
      }

      &--border {
        border-bottom: 1px solid $gray-2;
      }

      &__text {
        @extend %body;
        display: inline-block;

        &--bold {
          @extend %body-bold;
        }
      }

      &__chevron {
        &--black {
          fill: $black;
        }
        &--link {
          fill: $link;
        }
      }
    }

    &__body {
      overflow: hidden;
      transition: height 0.3s ease-in-out;
    }
  }
}
</style>
